export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-3xl border border-background-200/70 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-start gap-8">
            <div className="flex-shrink-0">
              <div className="w-20 h-20 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
                <i className="ri-fire-line text-3xl"></i>
              </div>
            </div>
            <div className="flex-1">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">关于本站</h2>
              <div className="mt-5 space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                <p>
                  黑料大赛成立于 2025 年，是国内领先的娱乐八卦资讯聚合平台。我们以"吃瓜现场"为核心理念，实时追踪网红撕逼、明星丑闻等热点事件，为全网吃瓜群众提供最新、最全的八卦资讯。
                </p>
                <p>
                  我们的编辑团队由资深娱乐媒体人和社交媒体分析师组成，7×24 小时不间断监控微博、抖音、小红书等主流平台，确保每一条热点八卦都能第一时间触达用户。所有内容均标注来源，坚持理性吃瓜、不传谣不信谣。
                </p>
                <p>
                  目前已累计追踪超过 500 个热点事件，发布深度专题 200+，拥有数百万忠实吃瓜用户。无论你是随手刷瓜的路人，还是深度吃瓜的资深群众，黑料大赛都能满足你的八卦需求。
                </p>
              </div>
              <div className="mt-6 flex flex-wrap gap-4 text-sm">
                <div className="flex items-center gap-2">
                  <span className="text-2xl font-heading font-bold text-accent-500">500+</span>
                  <span className="text-foreground-500">热点事件</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-2xl font-heading font-bold text-accent-500">200+</span>
                  <span className="text-foreground-500">深度专题</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-2xl font-heading font-bold text-accent-500">50+</span>
                  <span className="text-foreground-500">每周快讯</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}